import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import values from 'ramda/src/values';
import cx from 'classnames';
import Button from '@components/@core/AnimatedButton';
import EditDropdown from '@components/EditDropdown';
import Icon from '@components/@core/Icon';
import Pagination from '@components/@core/Pagination';
import AppActions from '~/actions/app';
import VendorActions from '~/actions/vendor';

const DotsMenu = ['Add Category', 'Delete', 'Edit'];

const CategoryMGTHeader = () => (
    <Row className="mx-0 d-none d-sm-flex">
        <Col xs={3} className="pl-0">
            <p className="dsl-m14 my-2">Category</p>
        </Col>
        <Col xs={1} className="d-h-end">
            <p className="dsl-m14 my-2">posts</p>
        </Col>
        <Col xs={1} className="d-h-end">
            <Icon name="far fa-eye" size={14} />
        </Col>
        <Col xs={1} className="d-h-end">
            <Icon name="far fa-thumbs-up" size={14} />
        </Col>
        <Col xs={1} className="d-h-end">
            <Icon name="far fa-comment" size={14} />
        </Col>
        <Col xs={4} className="pr-0">
            <p className="dsl-m14 my-2">Latest post</p>
        </Col>
        <Col xs={1} />
    </Row>
);

const CategoryMGTItem = ({ item, enable, onSelect }) => {
    const { name, latest, stats } = item;
    return (
        <Row className="mx-0 py-3 flex-column flex-sm-row">
            <Col xs={12} sm={3} className="d-h-start ps-0 mgt-sm-align">
                <label className="dsl-b12 d-block d-sm-none title-w">Category</label>
                <div className="category-logo me-2">
                    <Icon name={`fas fa-folder-open`} size={16} />
                </div>
                <p className="dsl-b16 mb-0 flex-grow-1">{name}</p>
                <div className="d-flex d-sm-none">{enable && <EditDropdown options={DotsMenu} onChange={onSelect(item)} />}</div>
            </Col>
            <Col xs={12} sm={1} className="d-h-end mgt-sm-align ps-0 ps-md-2">
                <label className="dsl-b12 d-block d-sm-none title-w">Posts</label>
                <p className="dsl-b16 mb-0">{stats?.posts}</p>
            </Col>
            <Col xs={12} sm={1} className="d-h-end mgt-sm-align ps-0 ps-md-2">
                <label className="dsl-b12 d-block d-sm-none title-w">Views</label>
                <p className="dsl-b16 mb-0">{stats?.views}</p>
            </Col>
            <Col xs={12} sm={1} className="d-h-end mgt-sm-align ps-0 ps-md-2">
                <label className="dsl-b12 d-block d-sm-none title-w">Likes</label>
                <p className="dsl-b16 mb-0">{stats?.likes}</p>
            </Col>
            <Col xs={12} sm={1} className="d-h-end mgt-sm-align ps-0 ps-md-2">
                <label className="dsl-b12 d-block d-sm-none title-w">Comments</label>
                <p className="dsl-b16 mb-0">{stats?.comments}</p>
            </Col>
            <Col xs={12} sm={4} className="d-h-start mgt-sm-align ps-0 ps-md-2">
                <label className="dsl-b12 d-block d-sm-none title-w">Latest Post</label>
                <p className="dsl-b14 text-500 truncate-one mb-0">{latest?.name}</p>
            </Col>
            <Col xs={12} sm={1} className="d-h-end pe-0 d-none d-sm-flex">
                {enable && <EditDropdown options={DotsMenu} onChange={onSelect(item)} />}
            </Col>
        </Row>
    );
};

const CategoryMGT = ({ blog, companyId, userId }) => {
    const dispatch = useDispatch();

    const [page, setPage] = useState(1);
    const categories = blog?.blog_categories ? values(blog?.blog_categories) : [];
    const total = Math.ceil(categories.length / 10);

    const handleSelectMenu = (type, index) => (item) => (e) => {
        switch (e) {
            case 'add category':
                handleAddCategory(type);
                break;

            case 'delete':
                handleDeleteConfirm(index);
                break;

            case 'edit':
                handleAddCategory(type, item, index);
                break;

            default:
                break;
        }
    };

    const handleAddCategory = (e, item, index = -1) => {
        const type = e === 'Public' ? 1 : 2;
        const payload = {
            type: 'Add Category',
            data: {
                before: { type, data: item, index, blog, companyId, userId },
                after: { type: 'GETCOMMUNITYUSER_REQUEST', payload: { userId } },
            },
        };
        dispatch(AppActions.modalRequest(payload));
    };

    const handleDeleteConfirm = (idx) => {
        const payload = {
            type: 'Confirm',
            data: { before: { title: 'Delete', body: 'Are you sure you want to delete this item?' } },
            callBack: {
                onYes: () => handleDeleteCategory(idx),
            },
        };
        dispatch(AppActions.modalRequest(payload));
    };

    const handleDeleteCategory = (idx) => {
        const newCategories = categories.map((e) => e.name);
        newCategories.splice(idx, 1);
        const payload = {
            data: { blog: { ...blog.blog, data: { categories: newCategories } } },
            after: { type: 'GETCOMMUNITYUSER_REQUEST', payload: { userId } },
        };
        dispatch(VendorActions.saveblogRequest(payload));
    };

    return (
        <div className="blog-admin-category-mgt">
            {categories.length > 0 ? (
                <>
                    <p className="dsl-b20 bold mb-2 mt-4">Public</p>
                    <CategoryMGTHeader />
                    {categories.map((item, index) => (
                        <CategoryMGTItem key={item.name} item={item} enable={!!blog?.has_blog && item.name !== 'Uncategorized'} onSelect={handleSelectMenu('Public', index)} />
                    ))}
                </>
            ) : (
                <p className="dsl-b16 mt-3">There are no categories.</p>
            )}
            <div className={cx('flex-column flex-sm-row mt-3', total > 1 ? 'd-h-between' : 'd-h-end')}>
                <Pagination total={total} current={page} pers={[]} onChange={(page) => setPage(page)} />
                {blog?.has_blog && <Button name="ADD CATEGORY" onClick={handleAddCategory} />}
            </div>
        </div>
    );
};

CategoryMGT.propTypes = {
    blog: PropTypes.shape({
        entity: PropTypes.any,
        blog: PropTypes.shape({
            entity_id: PropTypes.number,
            group_id: PropTypes.number,
            id: PropTypes.number,
        }),
        posts: PropTypes.shape({
            current_page: PropTypes.number,
            data: PropTypes.array,
            last_page: PropTypes.number,
        }),
        has_blog: PropTypes.bool,
    }),
    companyId: PropTypes.number,
    userId: PropTypes.number,
};

CategoryMGT.defaultProps = {
    blog: {
        entity: {},
        blog: {
            entity_id: 0,
            group_id: 0,
            id: 0,
        },
        posts: {
            current_page: 0,
            data: [],
            last_page: 0,
        },
        has_blog: false,
    },
    companyId: 0,
    userId: 0,
};

export default CategoryMGT;
